(function () {
  function readVariantDetails(root) {
    var node = root.querySelector('[data-aoy-variant-details]');
    if (!node) return [];

    try {
      return JSON.parse(node.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function appendTextElement(parent, className, text) {
    if (!text) return null;
    var element = document.createElement('span');
    element.className = className;
    element.textContent = text;
    parent.appendChild(element);
    return element;
  }

  function enhanceVariantCards(root) {
    var variants = readVariantDetails(root);
    if (!variants.length) return;

    var primaryFieldset = root.querySelector('.aoy-print-pdp__variants .main-product__fieldset');
    if (!primaryFieldset) return;

    primaryFieldset.querySelectorAll('.button--pill').forEach(function (label) {
      if (label.dataset.aoyEnhanced === 'true') return;

      var input = label.querySelector('input[type="radio"]');
      if (!input) return;
      var variant = variants.find(function (item) { return item.option1 === input.value; });
      if (!variant) return;

      Array.from(label.childNodes).forEach(function (node) {
        if (node.nodeType === Node.TEXT_NODE) node.remove();
      });

      label.dataset.aoyEnhanced = 'true';
      label.classList.add('aoy-print-pdp__variant-card');

      var head = document.createElement('span');
      head.className = 'aoy-print-pdp__variant-card-head';
      appendTextElement(head, 'aoy-print-pdp__variant-card-title', variant.title);
      appendTextElement(head, 'aoy-print-pdp__variant-card-price', variant.price);
      label.appendChild(head);

      var meta = [variant.edition, variant.presentation].filter(Boolean).join(' · ');
      appendTextElement(label, 'aoy-print-pdp__variant-card-meta', meta);
      appendTextElement(
        label,
        'aoy-print-pdp__variant-card-status',
        variant.available ? (root.dataset.stockLabel || 'In stock') : (root.dataset.soldLabel || 'Sold out')
      );
    });
  }

  function selectedVariant(root) {
    var variants = readVariantDetails(root);
    var checked = Array.from(root.querySelectorAll('.aoy-print-pdp__variants input[type="radio"]:checked'));
    if (!variants.length || !checked.length) return null;
    var selectedValues = checked.map(function (input) { return input.value; });
    return variants.find(function (item) {
      return (item.options || []).every(function (option, index) {
        return selectedValues[index] === option;
      });
    }) || null;
  }

  function syncVariantEditorial(root) {
    var variant = selectedVariant(root);
    if (!variant) return;

    var summary = root.querySelector('[data-aoy-variant-summary]');
    if (summary) {
      summary.textContent = variant.summary || '';
      summary.hidden = !variant.summary;
    }

    var availability = root.querySelector('[data-aoy-availability]');
    if (availability) {
      availability.textContent = variant.available
        ? (root.dataset.stockLabel || 'In stock')
        : (root.dataset.soldLabel || 'Sold out');
    }

    var mainButton = findMainButton(root);
    var mainText = mainButton && mainButton.querySelector('span:not(.cart-icon)');
    if (mainButton && mainText) {
      mainButton.disabled = !variant.available;
      mainText.textContent = variant.available
        ? (root.dataset.addLabel || 'Add to cart') + ' — ' + variant.price
        : (root.dataset.soldLabel || 'Sold out');
    }
  }

  function findMainButton(root) {
    return root.querySelector('.main-product__add-to-cart form[data-type="add-to-cart-form"] [name="add"]');
  }

  function syncStickyButton(root) {
    var stickyButton = document.querySelector('[data-aoy-sticky-submit]');
    var mainButton = findMainButton(root);
    if (!stickyButton || !mainButton) return;

    stickyButton.disabled = mainButton.disabled;

    var mainText = mainButton.querySelector('span:not(.cart-icon)');
    var stickyText = stickyButton.querySelector('span');
    if (mainText && stickyText) {
      stickyText.textContent = mainText.textContent;
    }
  }

  function submitMainForm(root) {
    var form = root.querySelector('.main-product__add-to-cart form[data-type="add-to-cart-form"]');
    var mainButton = findMainButton(root);
    if (!form || !mainButton || mainButton.disabled) return;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(mainButton);
      return;
    }

    mainButton.click();
  }

  function initPrintPdp() {
    var root = document.querySelector('.aoy-print-pdp[data-pdp-type="print"]');
    if (!root) return;

    var stickyButton = document.querySelector('[data-aoy-sticky-submit]');
    if (stickyButton && !stickyButton.dataset.aoyBound) {
      stickyButton.dataset.aoyBound = 'true';
      stickyButton.addEventListener('click', function () {
        submitMainForm(root);
      });
    }

    enhanceVariantCards(root);
    syncVariantEditorial(root);
    syncStickyButton(root);

    if (!root.dataset.aoyVariantBound) {
      root.dataset.aoyVariantBound = 'true';
      root.addEventListener('change', function (event) {
        if (!event.target.matches('.aoy-print-pdp__variants input[type="radio"]')) return;
        syncVariantEditorial(root);
      });
    }

    if (!document.documentElement.dataset.aoyPrintVariantBound) {
      document.documentElement.dataset.aoyPrintVariantBound = 'true';
      document.addEventListener('variant-update', function () {
        window.setTimeout(function () {
          var activeRoot = document.querySelector('.aoy-print-pdp[data-pdp-type="print"]');
          if (!activeRoot) return;
          enhanceVariantCards(activeRoot);
          syncVariantEditorial(activeRoot);
          syncStickyButton(activeRoot);
        }, 0);
      });
    }

    var mainForm = root.querySelector('.main-product__add-to-cart form[data-type="add-to-cart-form"]');
    if (mainForm && !mainForm.dataset.aoyBound) {
      mainForm.dataset.aoyBound = 'true';
      mainForm.addEventListener('submit', function () {
        window.setTimeout(function () {
          syncStickyButton(root);
        }, 0);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPrintPdp);
  } else {
    initPrintPdp();
  }

  document.addEventListener('shopify:section:load', initPrintPdp);
})();
